import React from "react";
import { OccupancyItem, OccupancyItemLabel, Stepper, StepperButton, StepperValue } from "../styles";

interface OccupancyStepperProps {
  label: string;
  value: number;
  min?: number;
  max: number;
  onStep: (delta: number) => void;
}

export function OccupancyStepper({ label, value, min = 0, max, onStep }: OccupancyStepperProps) {
  return (
    <OccupancyItem>
      <OccupancyItemLabel>{label}</OccupancyItemLabel>
      <Stepper>
        <StepperButton
          type="button"
          aria-label="-"
          disabled={value <= min}
          onClick={() => onStep(-1)}>
          −
        </StepperButton>
        <StepperValue>{value}</StepperValue>
        <StepperButton
          type="button"
          aria-label="+"
          disabled={value >= max}
          onClick={() => onStep(1)}>
          +
        </StepperButton>
      </Stepper>
    </OccupancyItem>
  );
}
